import { z } from 'zod'

export const tenantRoleSchema = z.enum(['Member', 'TenantAdministrator']).nullish().catch(undefined)

export const userDtoSchema = z.object({
  id: z.string(),
  tenantId: z.string(),
  email: z.string(),
  displayName: z.string().nullable().optional(),
  status: z.string(),
  isSuperAdmin: z.boolean().optional().default(false),
  isDevAdmin: z.boolean().optional().default(false),
  entraObjectId: z.string().nullable().optional(),
  avatarUrl: z.string().nullable().optional(),
  lastLoginAt: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string().nullable().optional(),
  tenantRole: tenantRoleSchema,
  identityLinked: z.boolean().optional().default(false),
})

export type UserDto = z.infer<typeof userDtoSchema>

export const pagedUserDataSchema = z.object({
  items: z.array(userDtoSchema),
  totalCount: z.number(),
  page: z.number(),
  pageSize: z.number(),
})

export const pagedUserResponseSchema = z.object({
  success: z.boolean(),
  data: pagedUserDataSchema,
})

export const userSingleResponseSchema = z.object({
  success: z.boolean(),
  data: userDtoSchema,
})
